import React, { useState } from 'react';
import { Text } from '@adc/parallax-component-library';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { PracticeErrorCode } from 'Enums';
import { useApiError, useLibrePractice } from 'Hooks';
import { Footer, Form, Input, Main, ScrollContainer, Spinner, TitleActionBar, } from 'Components/utility';
import { SHOW_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
const MAX_LENGTH_PRACTICE_ID = 16;
const MIN_LENGTH_PRACTICE_ID = 8;
const allowedChars = new RegExp(`^[A-Za-z0-9~!@#$%^&*()_+-={}|[\\]\\\\;:'"<>,.?/]{${MIN_LENGTH_PRACTICE_ID},${MAX_LENGTH_PRACTICE_ID}}$`);
const AddPracticeFirstStep = ({ next, values: valuesForm }) => {
    const [loading, setLoading] = useState(false);
    const { showApiErrorModal } = useApiError();
    const { validatePractice } = useLibrePractice();
    const validationSchema = Yup.object().shape({
        practiceID: Yup.string()
            .required(i18n.t('Connections.content.addPracticeID.formField.practiceID.errors.validPracticeId'))
            .matches(allowedChars, i18n.t('Connections.content.addPracticeID.formField.practiceID.errors.validPracticeId')),
    });
    const displayMessageError = (modalProps) => {
        store.dispatch({
            type: SHOW_MODAL,
            modalProps: modalProps,
        });
    };
    const onSubmit = async (formValues) => {
        try {
            setLoading(true);
            const { errorCode, practiceBody } = await validatePractice(formValues.practiceID);
            if (practiceBody) {
                return next(practiceBody);
            }
            switch (errorCode) {
                case PracticeErrorCode.COUNTRY_NOT_SUPPORTED_API:
                case PracticeErrorCode.PRACTICE_NOT_FOUND:
                case PracticeErrorCode.COUNTRY_NOT_SUPPORTED_LIBRE:
                    displayMessageError({
                        details: i18n.t('Connections.content.addPracticeID.formField.practiceID.errors.geographicPracticeIdError'),
                        testID: 'Geographic.practice.error',
                    });
                    break;
                case PracticeErrorCode.ALREADY_CONNECTED:
                    displayMessageError({
                        details: i18n.t('Connections.content.addPracticeID.formField.practiceID.errors.connectedToPracticeError'),
                        testID: 'Already.connected.practice',
                    });
                    break;
                case PracticeErrorCode.INVALID_PRACTICE_ID:
                    displayMessageError({
                        details: i18n.t('Connections.content.addPracticeID.formField.practiceID.errors.invalidPracticeId'),
                        testID: 'Invalid.practiceID',
                    });
                    break;
                default:
                    showApiErrorModal();
            }
        }
        catch {
            showApiErrorModal();
        }
        finally {
            setLoading(false);
        }
    };
    const { handleSubmit, handleChange, handleBlur, isValid, errors, touched, values } = useFormik({
        initialValues: { practiceID: valuesForm?.businessId },
        onSubmit,
        validationSchema,
        validateOnBlur: true,
    });
    return (React.createElement(Main, null,
        React.createElement(TitleActionBar, { testID: "AddPracticeID.primaryText", title: i18n.t('Connections.content.addPracticeID.primaryText'), closeBtn: true }),
        loading && React.createElement(Spinner, { "aria-label": "loading", testID: "AddPracticeID.spinner" }),
        React.createElement(ScrollContainer, { marginTop: 0 },
            React.createElement(Form, null,
                React.createElement(Text, { testID: "AddPracticeID.secondaryText", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default", color: "$text.100", marginBottom: "$2" }, i18n.t('Connections.content.addPracticeID.secondaryText')),
                React.createElement(Input, { "aria-label": i18n.t('Connections.content.addPracticeID.formField.practiceID.label'), placeholder: i18n.t('Connections.content.addPracticeID.formField.practiceID.label'), label: i18n.t('Connections.content.addPracticeID.formField.practiceID.label'), testID: "practiceID", inputMode: "text", maxLength: MAX_LENGTH_PRACTICE_ID, errorMessage: errors.practiceID, isInvalid: errors.practiceID && touched.practiceID ? true : false, value: values.practiceID, onChangeText: handleChange('practiceID'), onBlur: handleBlur('practiceID') }),
                React.createElement(Text, { testID: "AddPracticeID.body", fontSize: "$bodySmall.default", fontWeight: "$bodySmall.default", color: "$text.60", marginTop: "$3" }, i18n.t('Connections.content.addPracticeID.bodyText')))),
        React.createElement(Footer, { buttonText: i18n.t('Global.microcopy.common.next'), onButtonSubmit: handleSubmit, testIDButton: "AddPracticeID.common.next", isButtonDisabled: !values.practiceID || !isValid })));
};
export default AddPracticeFirstStep;
